// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3myiG","slider":"Home_slider__PR0rF","loaderChase":"Home_loaderChase__26TZe"};